import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index.js";
import axios from "axios";
import { SetToken, SetStageToken, SetUnind } from "../utils/token.js";
import { OLD_BASIC_URL, SSR_BASIC_URL } from "../constants/index.js";
const NEXT_BASIC_URL = process.env.VUE_APP_NEXT_BASIC_URL;
Vue.use(Router);

let routers = [
  {
    path: "/sign",
    name: "sign",
    component: () => import("../views/Sign"),
    //   beforeEnter: (to, from, next) => {
    //     console.log(to,from)
    //     // console.log(to.query.wechat)
    // }
  },
  {
    path: "/project-list",
    name: "projectlist",
    component: () => import("../views/Project/List"),
  },
  {
    path: "/redirect",
    name: "redirect",
    component: () => import("../views/redirect/index.vue"),
  },
  {
    name: "404",
    path: "*",
    component: () => import("../views/404.vue"),
  },
  {
    name: "linkFailure",
    path: "/link-failure",
    component: () => import("../views/link-failure.vue"),
  },
  {
    path: "/products",
    redirect: "Products",
    component: () => import("../views/Project/Detail"),
    children: [
      {
        path: "/products/:id",
        name: "Products",
        component: () => import("../views/Project/common/Products.vue"),
      },
      {
        path: "/enquiry-list/:id",
        name: "EnquiryList",
        component: () => import("../views/Project/common/EnquiryList.vue"),
      },
      {
        path: "/remark/:id",
        name: "Remark",
        component: () => import("../views/Project/common/Remark.vue"),
      },
      {
        path: "/enquiry-detail/:id/:enquiryId",
        name: "EnquiryDetail",
        component: () => import("../views/Project/common/EnquiryDetail.vue"),
      },
      /* 订单列表 */

      {
        path: "/order-list/:id",
        name: "OrderLists",
        component: () => import("../views/Project/common/OrderLists.vue"),
      },
      {
        path: "/team/:id",
        name: "Team",
        component: () => import("../views/Project/common/Team.vue"),
      },
      {
        path: "/design/:id",
        name: "Design",
        component: () => import("../views/Project/common/Design.vue"),
      },
    ],
  },
  {
    path: "/invitation",
    name: "Invitation",
    component: () => import("../views/Project/invitation.vue"),
  },
  {
    path: "/share-enquiry/:id",
    name: "ShareEnquiry",
    component: () => import("../views/Project/common/ShareEnquiry.vue"),
  },
  {
    path: "/commit",
    name: "CommitOrders",
    component: () => import("../views/orders/commit.vue"),
  },
  {
    path: "/contract/:id",
    name: "Contract",
    component: () => import("../views/orders/contract.vue"),
  },
  {
    path: "/details/:id",
    name: "OrderDetails",
    component: () => import("../views/orders/details.vue"),
  },
  {
    path: "/list/product",
    name: "ProductList",
    component: () => import("../views/list/productList.vue"),
  },
  {
    path: "/modify-details/:id",
    name: "ModifyDetails",
    component: () => import("../views/orders/modify-details.vue"),
  },
  {
    path: "/modify-item-record/:orderId/:orderItemId",
    name: "ModifyItemRecord",
    component: () => import("../views/orders/modify-item-record.vue"),
  },
  /* 个人中心 */
  {
    path: "/personal",
    name: "PersonlCenter",
    component: () => import("../views/personal"),
    children: [
      {
        path: "/my-center",
        name: "MyCenter",
        component: () => import("../views/personal/common/my-center.vue"),
      },
      {
        path: "/my-message",
        name: "MyMessage",
        component: () => import("../views/personal/common/my-message.vue"),
      },
      {
        path: "/my-todo",
        name: "MyTodo",
        component: () => import("../views/personal/common/my-todo.vue"),
      },
      {
        path: "/my-order",
        name: "MyOrder",
        component: () => import("../views/personal/common/my-order.vue"),
        meta: {
          activePath: "/my-order",
        },
      },
      {
        path: "/my-egg",
        name: "MyEgg",
        component: () => import("../views/personal/common/my-egg.vue"),
      },
      {
        path: "/egg-buy",
        name: "EggBuy",
        component: () => import("../views/personal/common/egg-buy.vue"),
        meta: {
          activePath: "/my-egg",
        },
      },
      {
        path: "/my-collect",
        name: "MyCollect",
        component: () => import("../views/personal/common/my-collect.vue"),
        meta: {
          activePath: "/my-collect",
        },
      },
      {
        path: "/my-collect-detail/:id",
        name: "MyCollectDetail",
        component: () =>
          import("../views/personal/common/my-collect-detail.vue"),
        meta: {
          activePath: "/my-collect",
        },
      },
      {
        path: "/my-coupon",
        name: "MyCoupon",
        component: () => import("../views/personal/common/my-coupon.vue"),
      },
      {
        path: "/my-address",
        name: "MyAddress",
        component: () => import("../views/personal/common/my-address.vue"),
      },
      {
        path: "/my-upgrade",
        name: "MyUpgrade",
        component: () => import("../views/personal/club/my-upgrade.vue"),
        meta: {
          activePath: "/my/personal/vip",
        },
      },
      {
        path: "/my-information",
        name: "MyInformation",
        component: () => import("../views/personal/common/my-information.vue"),
        meta: {
          activePath: "/my-information",
        },
      },
      {
        path: "/my-inquiry/:id",
        name: "MyInquiry",
        component: () => import("../views/personal/common/my-inquiry.vue"),
        meta: {
          activePath: "/my-inquiry/:id",
        },
      },

      {
        path: "/my-project",
        name: "MyProject",
        component: () => import("../views/personal/common/my-project.vue"),
        meta: {
          activePath: "/my-project",
        },
      },
      {
        path: "/my-price",
        name: "MyPrice",
        component: () => import("../views/personal/common/my-price.vue"),
        meta: {
          activePath: "/my-price",
        },
      },
      // 我的工作求职
      {
        path: "/my-work",
        name: "MyWork",
        component: () => import("../views/personal/common/my-work.vue"),
      },
      // 公司职位详情
      {
        path: "/work-company",
        name: "WorkCompany",
        component: () => import("../views/personal/common/work-company.vue"),
      },
    ],
  },

  /* 智能识图报价 */
  {
    path: "/smart",
    name: "Smart",
    component: () => import("../views/smart"),
  },
  {
    path: "/smart/clipping",
    name: "Clipping",
    component: () => import("../views/smart/clipping"),
  },
  /* 认证介绍界面 */
  {
    path: "/certification",
    name: "Certification",
    component: () => import("../views/certification"),
  },
  // app 隐私链接
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("../views/privacy"),
  },
  // 上传案例
  {
    path: "/uploadCase",
    name: "UploadCase",
    component: () => import("../views/uploadCase"),
  },

  // 工作职位
  {
    path: "/work-location",
    name: "WorkLocation",
    component: () => import("../views/workLocation/index.vue"),
  },
  // 找职位
  {
    path: "/find-work",
    name: "FindWork",
    component: () => import("../views/workLocation/findWork.vue"),
  },
  // 应聘者
  {
    path: "/worker-list",
    name: "WorkerList",
    component: () => import("../views/workLocation/workerLists.vue"),
  },
  // 职位详情
  {
    path: "/work-detail",
    name: "WorkDetail",
    component: () => import("../views/workLocation/workDetail.vue"),
  },
  // 找工作人员详情1
  {
    path: "/worker-detail-small",
    name: "WorkListsDetail",
    component: () => import("../views/workLocation/workListsDetail.vue"),
  },
  // 查看详细简历
  {
    path: "/worker-detail-view",
    name: "WorkListsDetailView",
    component: () => import("../views/workLocation/workListsDetailView.vue"),
  },
  // 设计工具介绍页
  {
    path: "/design-tools",
    name: "designTools",
    component: () => import("../views/designTools/index.vue"),
  },
];

const router = new Router({
  base: "next",
  mode: "history",
  routes: routers,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0,
    };
  },
});
/* 回到顶部 */
router.beforeEach((to, form, next) => {
  console.log(to.name);
  // console.log(to,form)
  if (to.name == "sign" || to.name == "Privacy") {
    store.dispatch("actiontipshow", false);
  } else {
    store.dispatch("actiontipshow", true);
    store.dispatch("getMsgCount");
  }

  let activePath = to.meta && to.meta.activePath ? to.meta.activePath : "";
  store.dispatch("getActivePath", activePath);

  if (to.query.wechat) {
    if (to.query.code) {
      let params = {
        code: to.query.code,
      };
      // localStorage.wechatCode = to.query.code;
      axios.post("/designer_api/account/qr_login", params).then((res) => {
        //  console.log(res)
        if (!res.accessToken) {
          SetUnind(res);
          window.location.href =
            NEXT_BASIC_URL + "/sign?redirect=" + to.query.redirect + "&bind=1";
          next();
        } else {
          SetToken(res.accessToken);
          SetStageToken(res.accessToken);
          window.location.href = SSR_BASIC_URL + "/";
        }
      });
      // .catch(err=>{
      //   window.location.href=NEXT_BASIC_URL+'/sign?redirect='+to.query.redirect+'&bind=1'
      // });
    } else {
      next();
    }
  } else {
    next();
  }
  // next()
});

export default router;
